/**
 * 聊天简易编辑器
 * Bai.Zhiming
 * 2019-7-15
 */
angular.module('chartEditorModule', []).
directive('chartEditor', ['$timeout', 'dialogBoxService', 'modalDialog', function($timeout, dialogBoxService, modalDialog) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            ce: "=",
            isEmpty: "=",
            enterSend: '&',
            loginInfo: '='
        },
        templateUrl: "./IM/chatWindow/dialogBox/directive/chartEditor/chartEditor_tpl.html",
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            initEditor();
            /**
             * [initEditor description] 初始化编辑器
             * @return {[type]} [description]
             */
            function initEditor() {
                $timeout(() => {
                    scope.isEmpty = true; //初始化时默认为空
                    scope.ce = {
                        /**
                         * [getContent description] 获取简易编辑器正文内容
                         * @return {[type]} [description]
                         */
                        getContent() {
                            return $element.find('.chart_editor').html();
                        },
                        /**
                         * [setContent description] 插入html正文
                         * @param {[type]} htmlContent [description]
                         */
                        setContent(htmlContent) {

                        },
                        /**
                         * [editorFocus description] 编辑器聚焦
                         * @return {[type]} [description]
                         */
                        editorFocus() {
                            $element.find('.chart_editor')[0].focus();
                        },
                        /**
                         * [insertHtml description] 插入内容
                         * @param  {[type]} content [description] 被插入的图片地址
                         * @return {[type]}         [description]
                         */
                        insertHtml(htmlContent) {
                            document.execCommand("insertHtml", 0, htmlContent);
                            isEmpty();
                        },
                        /**
                         * [clear description] 清空编辑器
                         * @return {[type]} [description]
                         */
                        clear() {
                            $element.find('.chart_editor').html('');
                            $element.find('.chart_editor')[0].focus();
                            $timeout(() => {
                                scope.isEmpty = true;
                            });
                        }
                    };
                });
            }
            /**
             * [isEmptyValidator description] 为空校验
             * @return {[type]} [description]
             */
            function isEmptyValidator() {
                $element.find('.chart_editor').bind("keyup", isEmpty);
                $("body").bind("mouseup", isEmpty);
                scope.$on("$destroy", () => {
                    $("body").unbind("mouseup", isEmpty);
                });
            }
            /**
             * [isEmpty description] 是否为空的事件
             * @param  {[type]}  e [description] 事件
             * @return {Boolean}   [description]
             */
            function isEmpty(e) {
                let html = $element.find('.chart_editor').text().replace(/ /g, "").replace(/&nbsp;/g, "").replace(/\n/g, '');
                let hasOtherTag = (() => {
                    if ($element.find('.chart_editor').find("img,video,iframe,audio").length > 0) return true;
                    return false;
                })();
                $timeout(() => {
                    if (html == "" && !hasOtherTag) {
                        scope.isEmpty = true;
                    } else {
                        scope.isEmpty = false;
                    }
                });
            }
            /**
             * [initEnterSend description] 初始化回车发送消息
             * @return {[type]} [description]
             */
            function initEnterSend() {
                $element.find('.chart_editor')[0].onkeydown = sendMessage;

                function sendMessage(e) {
                    if (e.keyCode == 13 && !e.shiftKey) { //默认的回车换行被禁止，改为回车发送信息
                        if (!scope.isEmpty) {
                            scope.enterSend();
                        }
                        return false;
                    }
                }
            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    dropUploadAccept: ['jpg', 'png', 'gif', 'bmp', 'jpeg']
                };
                scope.data = {};
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                isEmptyValidator();
                initEnterSend();
                initWatchPaste();
                initWatchDrop();
            }
            /**
             * [initWatchDrop description] 初始化拖拽放置时间
             * @return {[type]} [description]
             */
            function initWatchDrop() {
                $element[0].ondrop = function(e) {
                    let files = e.dataTransfer.files;
                    if (files.length == 0) return true;
                    for (let i in files) {
                        let file = files[0];
                        let type = file.type.split("/");
                        type = type[1];
                        if (scope.status.dropUploadAccept.indexOf(type) < 0) {
                            modalDialog.alertType(`抱歉，尚不支持${type}类型文件的上传`, '', 'warning', 'confirm');
                            return false;
                        }
                    }
                    scope.loaders = dialogBoxService.uploadImages(files, `${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`, 1).then(images => {
                        if (!angular.isArray(images) || images.length == 0) return;
                        let htmlContent = "";
                        images.forEach(resp => {
                            let img = document.createElement("img");
                            img.src = (() => {
                                return resp.URL_INFO.map(item => {
                                    return item.DownUrl
                                }).join("#");
                            })();
                            htmlContent += img.outerHTML;
                        });
                        scope.ce.editorFocus();
                        scope.ce.insertHtml(htmlContent);
                    });
                    return false;
                }
            }
            /**
             * [initWatchPaste description] 监控粘贴事件
             * @return {[type]} [description]
             */
            function initWatchPaste() {
                $element.find('.chart_editor')[0].onpaste = function(e) { //解决火狐浏览器不能发送聊天截图bug
                    let clipboardData = e.clipboardData;
                    if (clipboardData.types[0] == "Files" && clipboardData.files[0].type.indexOf('image') >= 0) {
                        return false;
                    }
                }
                $element.find('.chart_editor')[0].addEventListener("paste", e => {
                    let clipboardData = e.clipboardData;
                    if (clipboardData.types[0] == "Files" && clipboardData.files[0].type.indexOf('image') >= 0) {
                        scope.loaders = dialogBoxService.uploadImage(clipboardData.files[0], `${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`, '1').then(resp => {
                            let img = document.createElement("img");
                            img.src = (() => {
                                return resp.URL_INFO.map(item => {
                                    return item.DownUrl
                                }).join("#");
                            })();
                            scope.ce.insertHtml(img.outerHTML);
                        });
                    }
                })
            }
        }
    };
}]);